import request from '@/services/interceptor.js'

export const getCashflow = () => {
    return request({
        url: '/finanza/cashflow',
        method: 'get',
        loadingBar: true
    })
};

export const saveRecord = (par) => {
    return request({
        url: '/finanza/cashflow/save',
        method: 'post',
        data: par,
        loadingBar: true
    })
};


export const deleteRecord = (par) => {
    return request({
        url: '/finanza/cashflow/delete/' + par,
        method: 'delete',
        loadingBar: true
    })
};


export const saveCashflowSettings = (par) => {
    return request({
        url: '/finanza/cashflow/settings',
        method: 'post',
        data: par,
        loadingBar: true
    })
};


export const getCashflowSettings = () => {
    return request({
        url: '/finanza/cashflow/settings',
        method: 'get',
        loadingBar: true
    })
};

export const importData = () => {
    return request({
        url: '/finanza/cashflow/import',
        method: 'get',
        loadingBar: true
    })
};